import { ApiResponse, RoleTemplate, CustomRole } from '@/types'

const API_BASE = '/api/roles'

// 已棄用：取得所有角色模板 (使用統一角色系統)
export const getRoleTemplates = async (): Promise<ApiResponse<{ templates: RoleTemplate[] }>> => {
  // 返回空的模板列表，因為已改用統一角色系統
  return Promise.resolve({
    success: false,
    message: '模板系統已棄用，請使用統一角色系統',
    data: { templates: [] }
  })
}

// 已棄用：取得特定模板的角色 (使用統一角色系統)
export const getTemplateRoles = async (_templateId: string): Promise<ApiResponse<{ template: RoleTemplate }>> => {
  // 返回空的模板，因為已改用統一角色系統
  return Promise.resolve({
    success: false,
    message: '模板系統已棄用，請使用統一角色系統'
  })
}

// 取得專案可用的角色 (統一角色系統)
export const getProjectAvailableRoles = async (projectId: string): Promise<ApiResponse<{ 
  roles: CustomRole[] 
}>> => {
  // 在統一角色系統中，所有專案都使用相同的角色
  const response = await fetch(`/api/roles?projectId=${projectId}`, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
    }
  })
  return response.json()
}

// 已棄用：為專案設定角色模板 (使用統一角色系統)
export const setProjectRoleTemplate = async (
  _projectId: string, 
  _templateId: string | null
): Promise<ApiResponse<{ project: any }>> => {
  // 模板系統已棄用，返回相應訊息
  return Promise.resolve({
    success: false,
    message: '模板系統已棄用，請使用統一角色系統管理專案成員角色'
  })
}

// 創建角色 (統一角色系統)
export const createCustomRole = async (roleData: {
  name: string;
  description?: string;
  color?: string;
  permissions?: string[];
}): Promise<ApiResponse<{ role: CustomRole }>> => {
  const response = await fetch(`${API_BASE}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
    },
    body: JSON.stringify(roleData)
  })
  return response.json()
}

// 更新角色權限 (統一角色系統)
export const updateRolePermissions = async (
  roleId: string, 
  permissions: string[]
): Promise<ApiResponse<{ role: CustomRole }>> => {
  const response = await fetch(`${API_BASE}/${roleId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
    },
    body: JSON.stringify({ permissions })
  })
  return response.json()
}

// 刪除角色 (統一角色系統)
export const deleteCustomRole = async (roleId: string): Promise<ApiResponse> => {
  const response = await fetch(`${API_BASE}/${roleId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
    }
  })
  return response.json()
}
